import { useRef, useState } from "react";
import { Upload, Loader2, ImagePlus } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errorText } from "@/lib/api";

export const UploadPhoto = ({ cats, onUploaded }) => {
  const fileRef = useRef();
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [featured, setFeatured] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!file || !category) return toast.error("Elige una foto y una categoría");
    const fd = new FormData();
    fd.append("file", file); fd.append("title", title || category); fd.append("category", category); fd.append("featured", featured);
    setBusy(true);
    try {
      await api.post("/admin/photos", fd);
      toast.success("Foto subida");
      setFile(null); setTitle(""); setFeatured(false); fileRef.current.value = "";
      onUploaded();
    } catch (err) { toast.error(errorText(err, "No se pudo subir la foto")); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="bg-white rounded-2xl border p-5 grid md:grid-cols-[160px_1fr] gap-5" data-testid="upload-photo-form">
      <button type="button" onClick={() => fileRef.current.click()} className="aspect-square rounded-xl border-2 border-dashed grid place-items-center overflow-hidden hover:border-granate transition-colors" data-testid="upload-photo-pick-btn">
        {file ? <img src={URL.createObjectURL(file)} alt="" className="w-full h-full object-cover" /> : <span className="text-ink/50 text-xs flex flex-col items-center gap-2"><ImagePlus className="w-7 h-7" />Elegir foto</span>}
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="upload-photo-file-input" />
      <div className="space-y-3">
        <p className="font-display text-2xl">Subir nueva foto</p>
        <Input placeholder="Título (ej. Boda en el Pazo)" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={120} data-testid="upload-photo-title-input" />
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger data-testid="upload-photo-category-select"><SelectValue placeholder="Categoría" /></SelectTrigger>
          <SelectContent className="bg-white">{cats.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <label className="flex items-center gap-2 text-sm"><Switch checked={featured} onCheckedChange={setFeatured} data-testid="upload-photo-featured-switch" /> Mostrar en inicio</label>
          <Button type="submit" disabled={busy} className="rounded-full" data-testid="upload-photo-submit-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Upload className="w-4 h-4 mr-1" /> Subir</>}
          </Button>
        </div>
      </div>
    </form>
  );
};
